import React from "react";
import { ClipboardList, Settings, Truck } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const steps = [{
  step: "KROK 01",
  title: "Konzultace",
  description: "Začínáme důkladnou analýzou vašich požadavků, abychom zajistili logistickou strategii na míru, která odpovídá vašim obchodním cílům.",
  icon: ClipboardList
}, {
  step: "KROK 02",
  title: "Zpracování",
  description: "Naše automatizované systémy a expertní tým zpracovávají vaše objednávky s průmyslovou přesností, což zajišťuje přesnost a rychlost v každé fázi.",
  icon: Settings
}];
export default function DeliveryProcess() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}